export const PrintIcon = ({ color = "#FFFFFF", size = 20, ...props }) => (
    <svg
        width={size}
        height={size * (21 / 20)}
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#print-clip)">
            <path
                d="M15.8346 7.16667H4.16797C2.78464 7.16667 1.66797 8.28333 1.66797 9.66667V14.6667H5.0013V18H15.0013V14.6667H18.3346V9.66667C18.3346 8.28333 17.218 7.16667 15.8346 7.16667ZM13.3346 16.3333H6.66797V12.1667H13.3346V16.3333ZM15.8346 10.5C15.3763 10.5 15.0013 10.125 15.0013 9.66667C15.0013 9.20833 15.3763 8.83333 15.8346 8.83333C16.293 8.83333 16.668 9.20833 16.668 9.66667C16.668 10.125 16.293 10.5 15.8346 10.5ZM15.0013 3H5.0013V6.33333H15.0013V3Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="print-clip">
                <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);
